import { createAction } from "@reduxjs/toolkit";

export const SET_PREDICTIONS = createAction("SET_PREDICTIONS");
export const CREATE_UPDATE_PREDICTION = <T>() =>
  createAction<T>("UPDATE_PREDICTIONS");
export const SET_MODAL = createAction<{ data: { name: string } }>("SET_MODAL");
export const CLOSED_SIM_MODAL = createAction<{
  modalName: string;
  modalData: unknown;
}>("CLOSED_SIM_MODAL");
export const ITEM_DRAGGED = createAction<{
  itemId: number;
}>("ITEM_DRAGGED");
